import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import VisibilityIcon from '@material-ui/icons/Visibility'
import CancelIcon from '@material-ui/icons/Cancel'
import AddCircleIcon from '@material-ui/icons/AddCircle';
import {faUpload} from "@fortawesome/free-solid-svg-icons/faUpload";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons/faTrashAlt";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default {
    title: {
        id: 'MEDCAL_RX_DETAILS',
        heading: 'PA Response:',
        getSubHeadingHTML: (auth, status, priorAuthStatusFromView) => {
            if(auth){
                if (priorAuthStatusFromView !== "In Progress") {
                  return {
                    __html: `Your Prior Auth request with Authorization Number <b>${auth}`,
                  };
                }
                return {
                  __html: `Your Prior Auth request with Authorization Number <b>${auth}</b> is <b>${status}</b>`,
                };
            }
            return {__html:`Your Prior Auth request is <b>${status}</b>`}
        },
        resendVerbiageHeading: 'PA Request Status/Information Needed:'
    },
    backButton: {
        id: 'MEDCAL_RX_BACK_BUTTON',
        defaultMessage: 'Back',
    },
    requiredFields: {
        id: 'MEDCAL_RX_REQUIRED_FIELDS',
        defaultMessage: 'Required Fields',
    },
    apiError:{
        getMessage: code => `System encounter an error. Please try again later.`
    },
    dropzone: {
        id: 'MEDCAL_RX_DROPZONE_DEFAULT_MESSAGE',
        defaultMessageHTML: {__html: '<b>Drag and drop files here</b>, or click inside this box to choose file(s) to <b>upload.</b>'},
        maxNumFiles: {
            id: 'MEDCAL_RX_MAX_FILES_UPLOAD_ERROR',
            size: 10,
            text: 'Only maximum of 10 files allowed.'
        },
        maxFileSize: {
            size: 26214400, // 25MB size limit on files
            text: 'File size cannot exceed 25mb.',
            id: 'MEDCAL_RX_DROPZONE_MAX_FILE_SIZE_ERROR'
        }
    },
    uploadFileName: {
        size: '200px'    
    },
    fileList: {
        DeleteIcon: <DeleteIcon />,
        title: 'Files to Upload'
    },
    submitButton: {
        id: 'MEDCAL_RX_PA_UPLOAD_ATTACHMENTS_BUTTON',
        text: 'Upload Attachments',
        className: 'btn-secondary',
        icon: <FontAwesomeIcon icon={faUpload} />,
        tooltip: 'Upload Attachments',
        to: '',
        buttonStyle: {minWidth: '300px', maxWidth: '300px'}
    },
    viewPAButton: {
        id: 'MEDCAL_RX_VIEW_PA_BUTTON',
        text: 'View PA',
        className: 'btn-primary',
        icon: <VisibilityIcon />,
        tooltip: 'View PA',
        to: '',
        buttonStyle: {minWidth: '300px', maxWidth: '300px'}
    },
    cancelButton: {
        id: 'MEDCAL_RX_CANCEL_FILE_SUBMISSION_BUTTON',
        text: 'Cancel PA',
        className: 'btn-danger',
        icon: <CancelIcon />,
        tooltip: 'Cancel PA',
        to: '',
        buttonStyle: {minWidth: '300px', maxWidth: '300px'}
    },
    cancelSubmissionModal:{
        confirmText: 'Yes, Cancel',
        denyText: 'No, Go Back',
        confirmToolTip: 'Confirm Cancel',
        denyToolTip: 'Go back',
        title: 'Are you sure you want to cancel this upload request? All added information will be lost.'
    },
    removeFileUploadAction:{
        id: 'MEDCAL_RX_REMOVE_PA_ATTACHMENT',
        className: 'btn-danger',
        icon: <FontAwesomeIcon icon={faTrashAlt}/>,
        tooltip: 'Remove File',
        type: 'icon-only'
    },
    inquiryActions:[
        {
            id: 'MEDCAL_RX_UDATE_PA_BUTTON',
            text: 'Add Information',
            className: 'btn-secondary',
            icon: <AddCircleIcon />,
            tooltip: 'Add Information',
            to: '/update',
            operation: 'update',
            buttonStyle: {minWidth: '300px', maxWidth: '300px'}
        },
        {
            id: 'MEDCAL_RX_UPLOAD_PA_BUTTON',
            text: 'Upload Attachments',
            className: 'btn-primary',
            icon: <FontAwesomeIcon icon={faUpload}/>,
            tooltip: 'Upload Attachments',
            to: '/upload',
            operation: 'upload',
            buttonStyle: {minWidth: '300px', maxWidth: '300px'}
        },
        {
            id: 'MEDCAL_RX_CANCEL_PA_BUTTON',
            text: 'Cancel PA',
            className: 'btn-danger',
            icon: <CancelIcon />,
            tooltip: 'Cancel PA',
            to: '/cancel',
            operation: 'cancel',
            buttonStyle: {minWidth: '300px', maxWidth: '300px'}
        },
    ],
    cancelMessage: 'PA cancellation request successfully submitted, please allow 24 hours for this request to process.',
    errorMessage: 'System encounter an error. Please try again later.',
    getUpdateMessage: auth => `Additional Information successfully submitted for prior authorization ${auth}`,

}